<ng-container *ngIf="confirmedAt; else notConfirmed">
  <span>{{confirmedAt | timezone: 'MM/DD/YYYY hh:mm a' : user.time_zone }}</span>
</ng-container>
<ng-template #notConfirmed>
  <fa-icon
    class="ConfirmedUserIcon"
    [popoverOnHover]='true'
    [popoverPlacement]="'right'"
    popoverTitle="User not confirmed yet!"
    [popover]="'Please note, the account is not yet confirmed. No Campaigns, Follow Ups and Cycles will be sent out. Either reach out to the user and advise on following the instructions in the automatic confirmation email OR go to Actions and click Confirm user'"
    [icon]="warningIcon" size="1x"></fa-icon>
</ng-template>
